'use strict'

import * as types from '@/store/types.js'
import assets from '@/app/const/assets'
import { layouts, colorSchemes } from '@/app/const/settings'

const state = {
  loading: false,
  header: false,
  settings: {
    tryInit: false,
    colorScheme: {
      logo: assets.logo,
      code: layouts.default,
      executorTitle: null,
      ticketTitle: null,
      stateTitle: null,
      pageTimer: 0,
      adPolicy: 'DEFAULT'
    },
    layout: {
      code: colorSchemes.default
    }
  }
}

const mutations = {
  [types.GUI.loading.set]: (store, value) => {
    store.loading = value
  },
  [types.GUI.header.set]: (store, header) => {
    store.header = header
  },
  [types.GUI.settings.set]: (store, model) => {
    store.settings.colorScheme.logo = model.getColorScheme().getLogo()
    store.settings.colorScheme.code = model.getColorScheme().getCode()
    store.settings.colorScheme.ticketTitle = model.getColorScheme().getTicketTitle()
    store.settings.colorScheme.executorTitle = model.getColorScheme().getExecutorTitle()
    store.settings.colorScheme.stateTitle = model.getColorScheme().getStateTitle()
    store.settings.colorScheme.pageTimer = model.getColorScheme().getPageTimer()
    store.settings.colorScheme.adPolicy = model.getColorScheme().getAdPolicy()
    store.settings.layout.code = model.getLayout().getCode()
  },
  [types.GUI.tryInit.set]: (store) => {
    store.settings.tryInit = true
  }
}

const actions = {
  [types.GUI.loading.set] (context, value) {
    context.commit(types.GUI.loading.set, value)
  },
  [types.GUI.header.set] (context, header) {
    context.commit(types.GUI.header.set, header)
  },
  [types.GUI.settings.set] (context, model) {
    context.commit(types.GUI.settings.set, model)
  },
  [types.GUI.tryInit.set] (context) {
    context.commit(types.GUI.tryInit.set)
  }
}

export default {
  state,
  mutations,
  actions
}
